var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReferee)?_c('AppBtn',{staticClass:"heroes-pick-reset",attrs:{"color":"red-grad","round":""},on:{"click":_vm.resetPicks}},[_vm._v("Перезапустить пики")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }